import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import rrulePlugin from "@fullcalendar/rrule";
import luxon2Plugin, { toLuxonDateTime } from "@fullcalendar/luxon2";
import $ from "jquery";
import { Modal } from "bootstrap";
import { DateTime } from "luxon";

document.addEventListener("DOMContentLoaded", function () {
  const calendarEl = document.getElementById("calendar");

  const siteSlug = $(calendarEl).data("site-slug");
  const apiEndpoint = process.env.API_ENDPOINT;
  const subscribeUrl = `${apiEndpoint}/esites-api/v1/${siteSlug}/calendar/subscribe.ics`;

  const handleEventClick = ({ jsEvent, event }) => {
    jsEvent.preventDefault();

    const timeZone = calendar.getOption("timeZone");
    const modalEl = document.getElementById("modal");
    const $modalEl = $(modalEl);

    let title;

    const eventStart = toLuxonDateTime(event.start, calendar)
      .setZone(timeZone)
      .toFormat("ccc, DD, t");
    const eventEnd = toLuxonDateTime(event.end, calendar)
      .setZone(timeZone)
      .toFormat("t");

    if (event.end) {
      title = `
        <span style="font-size: 1.2rem;">${event.title}</span><br>
        <span>(${eventStart} to ${eventEnd})</span>
      `;
    } else {
      title = `
        <span style="font-size: 1.2rem;">${event.title}</span><br>
        <span>(${eventStart})</span>
      `;
    }

    $modalEl.find(".modal-title").html(title);
    $modalEl.find(".modal-body").html(event.extendedProps.description);

    let footer = `
      <a href="/esites-api/v1/${siteSlug}/calendar_events/${event.id}/download_ical" class="btn btn-outline-secondary">Add to my calendar</a> 
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    `;

    if (event.url) {
      footer = `
        <a href="${event.url}" target="_blank" class="btn btn-primary">
          <i class="fal fa-external-link"></i> Open event link
        </a>
        ${footer}
      `;
    }

    $modalEl.find(".modal-footer").html(footer);

    const modal = Modal.getInstance(modalEl);
    modal.show();
  };

  const eventsURL = `/esites-api/v1/${siteSlug}/calendar_events`;
  const eventsLocalTimezone = getEventsTimeZone();
  const localTimezone = DateTime.now().zoneName;

  const initialView = window.innerWidth < 500 ? "listWeek" : "dayGridMonth";

  const calendar = new Calendar(calendarEl, {
    timeZone: "UTC",
    height: "90%",
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      rrulePlugin,
      luxon2Plugin,
      listPlugin,
    ],
    headerToolbar: {
      left: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      center: "title",
      right: "prev,next today",
      bottom: "title",
    },
    initialView: initialView,
    eventDisplay: "block",
    events: eventsURL,
    eventSourceSuccess: function (content) {
      const events = convertEventsToLocationTZ(content);

      const filteredEvents = events.filter(
        (event) => event.display_on_calendar
      );

      return filteredEvents;
    },
    eventClick: handleEventClick,
    dayMaxEvents: true,
    dayMaxEventRows: 1,
    eventTimeFormat: {
      hour: "numeric",
      minute: "2-digit",
    },
  });

  calendar.render();

  compareTimezones(eventsLocalTimezone, localTimezone);
  hasMultipleLocation();
  addSubscribeButton();

  async function hasMultipleLocation() {
    const locations = await fetchLocations();
    if (locations.length > 1) {
      displayLocationsFilter();
    }
  }

  async function fetchLocations() {
    const response = await fetch(eventsURL);
    const events = await response.json();
    const filteredEvents = await events.filter(
      (event) => event.display_on_calendar
    );

    const locations = await filteredEvents.map((e) => {
      return {
        locationName: e.location_name,
        color: e.color,
      };
    });

    return locations.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (l) =>
            l.locationName === value.locationName && l.color === value.color
        )
    );
  }

  const convertEventsToLocationTZ = (events) => {
    return events.map((event) => ({
      ...event,
      start: convertDateTimeToLocationTZ(
        event.start,
        event.timezone_IANA,
        true
      ).toISO(),
      end: convertDateTimeToLocationTZ(
        event.end,
        event.timezone_IANA,
        true
      ).toISO(),
    }));
  };

  const convertDateTimeToLocationTZ = (dateTime, timezone, keepLocalTime) => {
    const luxonDate = DateTime.fromISO(dateTime, { zone: timezone });
    const newDatetime = luxonDate.setZone("UTC", {
      keepLocalTime: keepLocalTime,
    });

    return newDatetime;
  };

  // Display events in events timezone instead of client local timezone
  async function getEventsTimeZone() {
    const response = await fetch(eventsURL);
    const events = await response.json();
    const eventsTimezone = events[0];

    return eventsTimezone;
  }

  async function compareTimezones(eventsLocalTimezone, localTimezone) {
    const eventsTimezone = await eventsLocalTimezone;

    if (localTimezone != eventsTimezone.timezone_IANA) {
      timezoneMessage(eventsTimezone);
    }
  }

  const timezoneMessage = (eventsTimezone) => {
    const element = document.querySelector(".fc-view-harness");

    const message = document.createElement("div");
    message.innerHTML = `<p class="fw-lighter mt-2 mb-0">Times displayed in ${eventsTimezone.timezone_name} timezone </p>`;

    element.prepend(message);
  };

  function addSubscribeButton() {
    const element = document.querySelector(".fc-view-harness");
    const button = document.createElement("div");
    button.classList.add("d-flex");
    button.classList.add("justify-content-end");
    button.style.marginTop = "-1rem";

    button.innerHTML = `<button class="subscribe-button btn btn-outline-secondary">Subscribe</button>`;
    element.append(button);

    const buttonEl = document.querySelector(".subscribe-button");

    buttonEl.addEventListener("click", showSubscribeModal);
  }

  function showSubscribeModal() {
    const modalEl = document.getElementById("modal");
    const $modalEl = $(modalEl);

    const title = `
      <span style="font-size: 1.2rem;">Subscribe to The Calendar</span>
    `;

    const body = `
      <p>
        To subscribe to the Campaign Calendar, copy the link below and follow the instructions of 
        your calendar software (Google Calendar, Outlook, etc) on how to subscribe to a calendar.
      </p>
      <a style="text-decoration: none; color: black; font-weight: 500;">
        ${subscribeUrl}
      </a>
      <span class="copy-to-clipboard" style="cursor: pointer;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check-fill" viewBox="0 0 16 16">
          <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"/>
          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z"/>
        </svg>
      </span>
    `;

    const footer = `
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    `;

    $modalEl.find(".modal-title").html(title);
    $modalEl.find(".modal-body").html(body);
    $modalEl.find(".modal-footer").html(footer);

    const modal = Modal.getInstance(modalEl);
    modal.show();

    const copyIconEl = document.querySelector(".copy-to-clipboard");
    copyIconEl.addEventListener("click", function () {
      navigator.clipboard.writeText(subscribeUrl);
    });
  }

  async function displayLocationsFilter() {
    const element = document.querySelector("#calendar-container");

    const filterDiv = document.createElement("div");
    const locations = await fetchLocations();

    const markup = `
      <div class="d-flex flex-wrap align-items-center mt-2">
        <span class="mb-0 fw-bold">Filter by location:</span>
        <ul class="list-unstyled d-flex mb-0 flex-wrap">
        ${locations
          .map(
            (loc) => `
            <li class="px-2">
              <input type="checkbox" class="form-check-input" style="background-color: ${loc.color}; border-color:"white" checked="true" value="${loc.locationName}">
              <label>
                ${loc.locationName}
              </label>
            </li>
          `
          )
          .join("")}
        </ul>
      </div>
    `;

    filterDiv.innerHTML = markup;

    const checkBoxes = filterDiv?.querySelectorAll(".form-check-input");

    checkBoxes.forEach((cb) => {
      cb.addEventListener("click", () => {
        showHideEvents(cb);
      });
    });

    element.append(filterDiv);
  }

  function getAllEvents() {
    return calendar.getEvents();
  }

  function showHideEvents(checkBox) {
    const events = getAllEvents();

    if (checkBox.checked === true) {
      events.forEach((event) => {
        if (event.extendedProps.location_name === checkBox.value) {
          event.setProp("display", "block");
        }
      });
    } else {
      events.forEach((event) => {
        if (event.extendedProps.location_name === checkBox.value) {
          event.setProp("display", "none");
        }
      });
    }
  }
});
